import React, { MouseEventHandler, useCallback, useRef } from "react";
import { connect } from "react-redux";

import Email from "@mapmycustomers/shared/types/email/Email";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import ActivityAnnotationEditModal from "@app/component/activity/ActivityAnnotation/AnnotationEditModal";
import ActivityTypeIcon from "@app/component/activity/ActivityTypeIcon";
import { getEmailActivityType } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";

interface EmailActivityProps {
  className?: string;
  email: Email;
  emailActivityType: ActivityType;
}

const EmailActivity: React.FC<EmailActivityProps> = ({ className, email, emailActivityType }) => {
  const analytics = useAnalytics();

  const containerRef = useRef<HTMLDivElement>(null);
  const [modalOpen, openModal, closeModal] = useBoolean(false, true);

  const activityId = email.crmActivityIds?.[0];

  const handleActivityClick = useCallback(() => {
    openModal();
    analytics.clicked(["Open Email Activity"]);
  }, [analytics, openModal]);

  const handleContainerClick: MouseEventHandler = useCallback((e) => {
    e.stopPropagation();
  }, []);

  if (!activityId) {
    return null;
  }

  return (
    <div onClick={handleContainerClick}>
      <div className={className} onClick={handleActivityClick} ref={containerRef}>
        <ActivityTypeIcon activityType={emailActivityType} isAutoEmail size="md" />
      </div>
      {modalOpen && containerRef.current && (
        <ActivityAnnotationEditModal
          activityId={activityId}
          allowSendViaEmailClient={false}
          allowSendViaMmcEmail={false}
          element={containerRef.current}
          onHide={closeModal}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailActivityType: getEmailActivityType(state),
});

export default connect(mapStateToProps)(EmailActivity);
